import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/shared";
import { Video, FileText, Check } from "lucide-react";

export function GuideUploader() {
  const [status, setStatus] = useState({});
  const [busy, setBusy] = useState("");
  const load = () => api.get("/admin/guide-status").then((r) => setStatus(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const up = async (role, kind, file) => {
    if (!file) return;
    setBusy(`${role}_${kind}`);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post(`/admin/guide/${role}/${kind}`, fd);
      toast.success(`${role} ${kind} uploaded`);
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  const Row = ({ role, kind, label, Icon, acc }) => {
    const k = `${role}_${kind}`;
    return (
      <label className="inline-flex">
        <input type="file" accept={acc} className="hidden" data-testid={`guide-${role}-${kind}-input`} onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; up(role, kind, f); }} />
        <span className={`inline-flex items-center gap-1.5 font-mono text-[11px] uppercase px-3 py-2 border-2 cursor-pointer ${status[k] ? "border-emerald-700 text-emerald-300" : "border-zinc-700 text-white hover:border-[#FF5722]"} ${busy === k ? "opacity-50 pointer-events-none" : ""}`}>
          <Icon size={13} /> {busy === k ? "Uploading…" : label} {status[k] && <Check size={12} />}
        </span>
      </label>
    );
  };
  return (
    <Card className="p-4 space-y-3" data-testid="guide-uploader">
      <div className="font-head font-bold uppercase text-white text-sm tracking-wide">Tutorial video &amp; guide (upload your own)</div>
      <p className="font-mono text-[11px] text-zinc-500">Upload the recorded walkthrough video (MP4, up to 200MB) and PDF guide shown to contractors and clients on their profile and welcome emails.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="space-y-2"><div className="font-mono text-[10px] uppercase text-[#FF5722]">Contractor</div><div className="flex gap-2 flex-wrap"><Row role="crew" kind="video" label="Video" Icon={Video} acc="video/*" /><Row role="crew" kind="pdf" label="PDF" Icon={FileText} acc="application/pdf" /></div></div>
        <div className="space-y-2"><div className="font-mono text-[10px] uppercase text-[#FF5722]">Client</div><div className="flex gap-2 flex-wrap"><Row role="client" kind="video" label="Video" Icon={Video} acc="video/*" /><Row role="client" kind="pdf" label="PDF" Icon={FileText} acc="application/pdf" /></div></div>
      </div>
    </Card>
  );
}
